<template>
  <SideComponent show-sidebar-login @scrollto="scroll" />

  <Login2
    :show-dialog="showDialog"
    :show-login="showLogin"
    :show-mobile="showMobile"
    @update:show-dialog="onLoginDialogChange"
  />

  <div ref="pageRoot" class="ni-page">
    <NewIndexHeader
      :lang="lang"
      :is-logged-in="isLoggedIn"
      @search="handleSearch"
      @update:lang="setLang"
      @login="openLogin"
    />

    <main class="ni-page__main">
      <NewsCarousel :lang="lang" :news-list="pageData.newsList" />
      <SloganSlider :lang="lang" :scenes="pageData.sloganScenes" />
      <SpotsGrid :lang="lang" :spot-cards="pageData.spotCards" />
      <IntCommunicator :lang="lang" />
      <PhotoDepot
        :lang="lang"
        :hot-photos="pageData.hotPhotos"
        :subject-cats="pageData.subjectCats"
      />
      <VisualQingdao :lang="lang" :videos="pageData.visualVideos" />
      <VrExhibition :lang="lang" :vr-list="pageData.vrList" />
      <AskQingdao :lang="lang" />
    </main>

    <Footer />

    <Transition name="ni-toast">
      <div v-if="toastMessage" class="ni-toast">
        <span class="ni-toast__icon ni-animate-spin-slow">◎</span>
        <div class="ni-toast__body">
          <span class="ni-toast__text">{{ toastMessage }}</span>
          <span class="ni-toast__sub">RETRIEVING FROM CLOUD SERVICE...</span>
        </div>
      </div>
    </Transition>

  </div>
</template>

<script>
import newIndex from './new_index_controller';
export default newIndex;
</script>

<style src="@/assets/css/new_index_tokens.css"></style>
<style src="@/assets/css/new_index.css"></style>
